import { defineHotpadsEvent, trackHotpadsEventDefinition } from '../track';
import type { ListingArg, RentalSubmitArg, TriggerArg } from './types';

const LEGACY_SOURCE = 'srcLegacy/shared/models/Clickstream/TourClickstreamEvents.ts';

const TOUR_CLICK = defineHotpadsEvent({
  key: 'tour.click',
  eventTypeId: '10452',
  eventTypeVersionId: '1',
  eventTemplateId: '4',
  eventTemplateVersionId: '1',
  trigger: {
    type: 'interaction',
    location: 'home_details',
    source: 'button_to_open_book_tour_now_form',
    object: 'home_details_component|instant_tour_modal',
  },
  semanticEvent: 'instant_tour_click',
});

export function emitTrackTourClickEvent({
  listing,
  triggerLocation,
}: ListingArg & Pick<TriggerArg, 'triggerLocation'>) {
  trackHotpadsEventDefinition(TOUR_CLICK, { listing, triggerLocation });
}

const TOUR_REQUEST_SUBMIT = defineHotpadsEvent({
  key: 'tour.request_submit',
  eventTypeId: '5986',
  eventTypeVersionId: '2',
  eventTemplateId: '68',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackTourRequestSubmitEvent',
  trigger: {
    type: 'interaction',
    location: 'home_details',
    source: 'button_to_submit_instant_tour',
    object: 'home_details_component|instant_tour_modal',
  },
  semanticEvent: 'instant_tour_submit',
});

const TOUR_REQUEST_FAILED = defineHotpadsEvent({
  key: 'tour.request_failed',
  eventTypeId: '5988',
  eventTypeVersionId: '1',
  eventTemplateId: '4',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackTourRequestFailedEvent',
  trigger: {
    type: 'interaction',
    location: 'home_details',
    source: 'button_to_submit_instant_tour',
    object: 'home_details_component|instant_tour_modal',
  },
  semanticEvent: 'instant_tour_failure',
});

const TOUR_REQUEST_SUCCESS = defineHotpadsEvent({
  key: 'tour.request_success',
  eventTypeId: '5987',
  eventTypeVersionId: '1',
  eventTemplateId: '4',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackTourRequestSuccessEvent',
  trigger: {
    type: 'interaction',
    location: 'home_details',
    source: 'button_to_submit_instant_tour',
    object: 'home_details_component|instant_tour_modal',
  },
  semanticEvent: 'instant_tour_success',
});

export function emitTrackTourRequestSubmitEvent({
  listing,
  rentalSubmitId,
  triggerLocation,
}: ListingArg & RentalSubmitArg & Pick<TriggerArg, 'triggerLocation'>) {
  trackHotpadsEventDefinition(TOUR_REQUEST_SUBMIT, { listing, rentalSubmitId, triggerLocation });
}

export function emitTrackTourRequestFailedEvent({
  listing,
  triggerLocation,
}: ListingArg & Pick<TriggerArg, 'triggerLocation'> = {}) {
  trackHotpadsEventDefinition(TOUR_REQUEST_FAILED, { listing, triggerLocation });
}

export function emitTrackTourRequestSuccessEvent({
  listing,
  triggerLocation,
}: ListingArg & Pick<TriggerArg, 'triggerLocation'> = {}) {
  trackHotpadsEventDefinition(TOUR_REQUEST_SUCCESS, { listing, triggerLocation });
}
